import type { TechDef } from './types';

/** Research tech tree. Researched with points produced by Labs. */
export const TECHS: readonly TechDef[] = [
  {
    id: 'prospecting', name: 'Prospektion', icon: '🧭', cost: 20, deps: [],
    description: 'Untersuche das Gestein. +25% Abbau.',
    effect: { type: 'autoMult', value: 1.25 },
  },
  {
    id: 'smelting', name: 'Verhüttung', icon: '🔥', cost: 60, deps: ['prospecting'],
    description: 'Schaltet den Schmelzofen frei.',
    effect: { type: 'globalMult', value: 1.05 },
  },
  {
    id: 'hydraulics', name: 'Hydraulik', icon: '💧', cost: 150, deps: ['prospecting'],
    description: 'Bohrer ×1,5.',
    effect: { type: 'autoMult', value: 1.5 },
  },
  {
    id: 'metallurgy', name: 'Metallurgie', icon: '🪙', cost: 320, deps: ['smelting'],
    description: 'Verkaufswert ×1,4.',
    effect: { type: 'valueMult', value: 1.4 },
  },
  {
    id: 'automation', name: 'Automatisierung', icon: '⚙️', cost: 700, deps: ['hydraulics'],
    description: 'Schaltet Bergbau-Ingenieure frei. Auto ×1,5.',
    effect: { type: 'autoMult', value: 1.5 },
  },
  {
    id: 'powergrid', name: 'Stromnetz', icon: '🔌', cost: 1_200, deps: ['hydraulics'],
    description: 'Energieerzeugung ×1,5.',
    effect: { type: 'energyMult', value: 1.5 },
  },
  {
    id: 'explosives', name: 'Sprengstoff', icon: '🧨', cost: 2_500, deps: ['automation'],
    description: 'Abbau ×2.',
    effect: { type: 'autoMult', value: 2 },
  },
  {
    id: 'robotics', name: 'Robotik', icon: '🤖', cost: 6_000, deps: ['automation', 'powergrid'],
    description: 'Schaltet Bergbau-Androiden frei. Arbeiter ×1,5.',
    effect: { type: 'workerMult', value: 1.5 },
  },
  {
    id: 'nanotech', name: 'Nanotechnik', icon: '🧬', cost: 15_000, deps: ['explosives', 'robotics'],
    description: 'Alles ×1,5 (global).',
    effect: { type: 'globalMult', value: 1.5 },
  },
  {
    id: 'ai', name: 'Künstliche Intelligenz', icon: '🧠', cost: 40_000, deps: ['nanotech'],
    description: 'Schaltet das Betriebs-KI-Upgrade frei. Alles ×1,5.',
    effect: { type: 'globalMult', value: 1.5 },
  },
  {
    id: 'cryogenics', name: 'Kryotechnik', icon: '❄️', cost: 90_000, deps: ['explosives'],
    description: 'Verkaufswert ×1,6.',
    effect: { type: 'valueMult', value: 1.6 },
  },
  {
    id: 'gravitonics', name: 'Gravitonik', icon: '🪐', cost: 200_000, deps: ['ai'],
    description: 'Abbau ×2,5.',
    effect: { type: 'autoMult', value: 2.5 },
  },
  {
    id: 'antimatter', name: 'Antimaterie-Theorie', icon: '🌗', cost: 600_000, deps: ['gravitonics', 'cryogenics'],
    description: 'Alles ×2 (global).',
    effect: { type: 'globalMult', value: 2 },
  },
] as const;

export const TECH_BY_ID: Record<string, TechDef> = Object.fromEntries(
  TECHS.map((t) => [t.id, t]),
);
